import { Grid } from '@mui/material'
import Loading from 'components/Loading'
import SoftBox from 'components/SoftBox'
import MiniStatisticsCard from 'examples/Cards/StatisticsCards/MiniStatisticsCard'
import ReportsBarChart from 'examples/Charts/BarCharts/ReportsBarChart'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import moment from 'jalali-moment'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { getStats } from 'services/stats.routes'
import separate from 'utils/separate'

export default function Dashboard() {
    const [loading, setLoading] = useState(false);
    const [stats, setStats] = useState({})
    const reportsBarChartData = {
        chart: {
            labels: stats?.gio_opportunity?.map(item => item.opportunity_name),
            datasets: { label: "مقدار", data: stats?.gio_opportunity?.map(item => parseInt(item.total_balance)) },
        },
        ghollak_data: {
            labels: stats?.ghollak_daily_transactions?.map(item => moment(item.day, 'YYYY-MM-DD').format('jYYYY/jMM/jDD')),
            datasets: { label: "مبلغ", data: stats?.ghollak_daily_transactions?.map(item => parseInt(item.total_amount)) },
        },
    };
    const { chart, ghollak_data } = reportsBarChartData;

    useEffect(() => {
        setLoading(true);
        getStats((isOk, data) => {
            setLoading(false);
            if (!isOk) {
                return toast.error(data.message)
            } else {
                setStats(data)
            }
        })
    }, [])
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Loading loading={loading} />
            <SoftBox py={3}>
                <SoftBox mb={3}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} xl={3}>
                            <MiniStatisticsCard
                                title={{ text: "تعداد کاربران" }}
                                count={stats?.users_count}
                                icon={{ color: "info", component: "person" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} xl={3}>
                            <MiniStatisticsCard
                                title={{ text: "تعداد فرصت ها" }}
                                count={stats?.investment_opportunities_count}
                                icon={{ color: "secondary", component: "savings" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} xl={3}>
                            <MiniStatisticsCard
                                title={{ text: "کل سرمایه گذاری انجام شده (تومان)" }}
                                count={separate(parseInt(stats?.total_investments))}
                                icon={{ color: "success", component: "attach_money" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} xl={3}>
                            <MiniStatisticsCard
                                title={{ text: "تعداد نشان های دریافت شده کاربران" }}
                                count={stats?.user_badges_count}
                                icon={{ color: "warning", component: "workspace_premium" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} xl={3}>
                            <MiniStatisticsCard
                                title={{ text: "تعداد اهداف" }}
                                count={stats?.target_count}
                                icon={{ color: "dark", component: "adjust" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} xl={3}>
                            <MiniStatisticsCard
                                title={{ text: "تعداد ماموریت ها" }}
                                count={stats?.missions_count}
                                icon={{ color: "error", component: "tour" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} xl={3}>
                            <MiniStatisticsCard
                                title={{ text: "ماموریت های در حال انجام" }}
                                count={stats?.missions_in_progress}
                                icon={{ color: "secondary", component: "tour" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} xl={3}>
                            <MiniStatisticsCard
                                title={{ text: "ماموریت های در انتظار تایید" }}
                                count={stats?.missions_pending_approval}
                                icon={{ color: "info", component: "fact_check" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} xl={3}>
                            <MiniStatisticsCard
                                title={{ text: "تراکنش های بانکی" }}
                                count={separate(parseInt(stats?.payment_transactions))}
                                icon={{ color: "primary", component: "credit_card" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} xl={3}>
                            <MiniStatisticsCard
                                title={{ text: "تراکنش های کیف پول" }}
                                count={separate(parseInt(stats?.wallet_transactions))}
                                icon={{ color: "success", component: "wallet" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} xl={3}>
                            <MiniStatisticsCard
                                title={{ text: "جوانه" }}
                                count={separate(parseInt(stats?.investor_ghollaks?.count))}
                                icon={{ color: "dark", component: "eco" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} xl={3}>
                            <MiniStatisticsCard
                                title={{ text: "مبلغ سرمایه گذاری جوانه" }}
                                count={separate(parseInt(stats?.investor_ghollaks?.total_amount))}
                                icon={{ color: "warning", component: "eco" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} xl={6}>
                            <MiniStatisticsCard
                                title={{ text: "نو جوانه" }}
                                count={separate(parseInt(stats?.child_ghollaks?.count))}
                                icon={{ color: "error", component: "grass" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} xl={6}>
                            <MiniStatisticsCard
                                title={{ text: "مبلغ سرمایه گذاری نو جوانه" }}
                                count={separate(parseInt(stats?.child_ghollaks?.total_amount))}
                                icon={{ color: "info", component: "grass" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} xl={6}>
                            <ReportsBarChart
                                title="کل سرمایه گذاری های هر فرصت"
                                chart={chart}
                                color="primary"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} xl={6}>
                            <ReportsBarChart
                                title="مجموع سرمایه گذاری به تفکیک روز"
                                chart={ghollak_data}
                                color="dark"
                            />
                        </Grid>
                    </Grid>
                </SoftBox>
            </SoftBox>
        </DashboardLayout>
    )
}
